import { createRouter, createWebHashHistory } from 'vue-router';
import IntroSection from '../components/IntroSection.vue';

const routes = [
    {
        path: '/',
        name: 'Intro',
        component: IntroSection,
    },
    {
        path: '/chapter1',
        name: '1',
        component: () => import(/* webpackChunkName: "about" */ '../components/chapter/chapter01/Chapter01.vue'),
    },
    {
        path: '/chapter2',
        name: '2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/chapter/chapter02/Chapter02.vue'),
    },
    {
        path: '/chapter3',
        name: '3',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/chapter/chapter03/Chapter03.vue'),
    },
    {
        path: '/chapter4',
        name: '4',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/chapter/chapter04/Chapter04.vue'),
    },
    {
        path: '/chapter5',
        name: '5',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/chapter/chapter05/Chapter05.vue'),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior: function (to) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else {
            return { top: 0 };
        }
    },
});

export default router;
